import script from "./BaseButton.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseButton.vue?vue&type=script&setup=true&lang=js"

import "./BaseButton.vue?vue&type=style&index=0&id=8ea12052&lang=scss&scoped=true"

import exportComponent from "/builds/strooka-jagaad/strooka-fe/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8ea12052"]])

export default __exports__